var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"d-flex align-items-center category-select",class:{
      selected: _vm.enabledCategories[category.id],
      readonly: _vm.readonly,
    },on:{"click":function($event){return _vm.toggle(category.id)}}},[(_vm.enabledCategories[category.id])?_c('i',{staticClass:"fas fa-circle-check mr-2",style:({ color: _vm.categoryColor(category.id) })}):_c('i',{staticClass:"far fa-circle mr-2"}),_c('div',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(category.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }